import React from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import Button from '../button/index';
import TextArea from '../text-area/index';
import { useParkCart } from '../../../integrations/react_query/mutations';

type TParkValues = {
	note: string;
};

const initialValues: TParkValues = {
	note: '',
};

type ParkSalesContentProps = {
	onClose: () => void;
};

export const ParkSalesContent = ({ onClose }: ParkSalesContentProps) => {
	const { mutateAsync, isLoading } = useParkCart();

	const onSubmit = async (values: TParkValues, actions: FormikHelpers<TParkValues>) => {
		await mutateAsync(values.note);
		onClose();
	};

	return (
		<div className="px-5 py-4">
			<Formik initialValues={initialValues} onSubmit={onSubmit}>
				{({ values, setFieldValue, isSubmitting }) => (
					<Form>
						<div className="my-4">
							<TextArea
								label="Note"
								name="note"
								placeholder="Add a note for this parked sale..."
								value={values.note}
								onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setFieldValue('note', e.target.value)}
							/>
						</div>

						<div className="w-100 text-center my-3">
							<Button type="submit" disabled={isLoading} style={{ width: '40%' }} styles="py-4">
								{isLoading ? 'Parking...' : 'Continue'}
							</Button>
						</div>
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default ParkSalesContent;
